<template>
  <div :class="$style.container">
    <HeerAmisEditor v-show="mode === 'design'" id="amisEditor" theme="cxd" :isMobile="isMobile" :value="value" :plugins="plugins" :showCustomRenderersPanel="true" :amisEnv="env" @onChange="onChange" class="amisEditor" />
    <AmisPreviewer v-if="mode === 'review'" :class="[$style['preview-container']]" :value="buildPreviewSchema()" :isMobile="isMobile" :env="env" />
  </div>
</template>
<script>
import { ReactInVue } from "vuera"
import { Editor } from 'amis-editor'
import 'amis-editor-core/lib/style.css'
import AmisPreviewer from './AmisPreviewer.vue'

export default {
  name: 'AmisEditor',
  components: {
    HeerAmisEditor: ReactInVue(Editor),
    AmisPreviewer
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => []
    },
    env: {
      type: Object
    },
    mode: {
      type: String,
      default: 'design'
    }
  },
  watch: {
    'isMobile': {
      handler(val) {
        console.log(val)
      }
    }
  },
  model: {
    event: 'change'
  },
  methods: {
    onChange(v) {
      this.$emit('change', v)
    },
    buildPreviewSchema() {
      const schema = JSON.parse(JSON.stringify(this.value))
      return schema
    }
  }
}
</script>
<style lang="less" module>

.container {
  position: relative;
  height: 100%;
}

.preview-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  display: block;
}

.amisEditor {

  ::v-deep .cxd-Form-item--normal > .cxd-Form-label {
    text-align: left;
  }
}

</style>